/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Parq_1Inputs */

const en_us2_onboarding_parq_1 = /** @type {(inputs: Onboarding_Parq_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Has a doctor ever said you have a heart condition and should only do physical activity with medical supervision?`)
};

const pt_br2_onboarding_parq_1 = /** @type {(inputs: Onboarding_Parq_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algum médico já disse que você tem um problema cardíaco e que só deveria fazer atividade física com supervisão médica?`)
};

const es_419_onboarding_parq_1 = /** @type {(inputs: Onboarding_Parq_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Algún médico te ha dicho que tienes un problema cardíaco y que solo deberías hacer actividad física con supervisión médica?`)
};

const pt_pt2_onboarding_parq_1 = /** @type {(inputs: Onboarding_Parq_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algum médico já te disse que tens um problema cardíaco e que só deverias fazer atividade física com supervisão médica?`)
};

const fr_fr2_onboarding_parq_1 = /** @type {(inputs: Onboarding_Parq_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un médecin t'a-t-il déjà dit que tu avais un problème cardiaque et que tu ne devais faire de l'activité physique que sous supervision médicale ?`)
};

const de_de2_onboarding_parq_1 = /** @type {(inputs: Onboarding_Parq_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hat dir ein Arzt jemals gesagt, dass du eine Herzerkrankung hast und dich nur unter ärztlicher Aufsicht körperlich betätigen solltest?`)
};

const it_it2_onboarding_parq_1 = /** @type {(inputs: Onboarding_Parq_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un medico ti ha mai detto che hai un problema cardiaco e che dovresti fare attività fisica solo sotto controllo medico?`)
};

/**
* | output |
* | --- |
* | "Has a doctor ever said you have a heart condition and should only do physical activity with medical supervision?" |
*
* @param {Onboarding_Parq_1Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_parq_1 = /** @type {((inputs?: Onboarding_Parq_1Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Parq_1Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_parq_1(inputs)
	if (locale === "es-419") return es_419_onboarding_parq_1(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_parq_1(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_parq_1(inputs)
	if (locale === "de-DE") return de_de2_onboarding_parq_1(inputs)
	if (locale === "it-IT") return it_it2_onboarding_parq_1(inputs)
	return en_us2_onboarding_parq_1(inputs)
});
export { onboarding_parq_1 as "onboarding.parq.1" }